
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChevronRight, LineChart } from 'lucide-react';
import AnalyticsChart from '@/components/dashboard/AnalyticsChart';

const PerformanceOverview: React.FC = () => {
  return (
    <Card className="neo-card overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <div className="space-y-1">
          <CardTitle className="text-xl flex items-center gap-2">
            <LineChart className="h-5 w-5 text-muted-foreground" />
            Performance Overview
          </CardTitle>
          <CardDescription>Your music analytics at a glance</CardDescription>
        </div>
        <Button variant="ghost" size="sm" asChild>
          <Link to="/analytics" className="gap-1">
            <span>Full Analytics</span>
            <ChevronRight className="h-4 w-4" />
          </Link>
        </Button>
      </CardHeader>
      <CardContent>
        <div className="h-60">
          <AnalyticsChart />
        </div>
      </CardContent>
    </Card>
  );
};

export default PerformanceOverview;
